import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import ChartContainer from './chart';
import ZoneModel from '../../../../models/zoneModel';
import { Loader } from 'semantic-ui-react';
import TranslationContainer from './translation/translation';
import { WeezHeader, SplitContainer, Message, FrameCard } from '@weezevent/nacre';

export default function ChartCustomContainer({ organization, chartId }) {
    const { t } = useTranslation();
    const [zones, loadingZones, syncZones] = ZoneModel.useApiModel({ organizationId: organization.pk, chartId: chartId, query: { includes_deleted_zones: true } });
    return (
        <div>
            <WeezHeader title={<Trans i18nKey="ticket.charts.custom.title" />}>{<Trans i18nKey="ticket.charts.custom.subtitle" />}</WeezHeader>
            <SplitContainer
                additional={
                    <Message type="tips" title={t('notifications.tips_title')} mini>
                        <p>{t('ticket.charts.custom.tips')}</p>
                    </Message>
                }
            >
                <FrameCard title={t('ticket.chart.settings.title')}>
                    {loadingZones ? (
                        <Loader active style={{ position: 'relative', marginTop: '20px' }} />
                    ) : (
                        <ChartContainer organization={organization} chartId={chartId} zones={zones} syncZones={syncZones} />
                    )}
                </FrameCard>
            </SplitContainer>
            <TranslationContainer organization={organization} chartId={chartId} zones={zones} syncZones={syncZones} loadingZones={loadingZones} />
        </div>
    );
}
